/*
 * @Author: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @Date: 2026-08-10 11:43:09
 * @LastEditors: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @LastEditTime: 2026-08-10 13:55:50
 * @FilePath: \newenergy\src\store\agentMapStore.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'

// 智能体 -> 地图联动共享状态（Vue2 用 Vue.observable 实现响应式总线）
// focus:    { lng, lat, name, ts }  点定位
// boundary: { geojson, name, ts }   行政边界 GeoJSON
const state = Vue.observable({
  focus: null,
  boundary: null
})

export const mapStore = state

export function focusMap(lng, lat, name) {
  // ts 必带：即便连续定位同一地点，也能触发 watch 重新飞行
  state.focus = { lng, lat, name: name || '目标', ts: Date.now() }
}

export function drawBoundary(geojson, name) {
  state.boundary = { geojson, name: name || '目标', ts: Date.now() }
}
